var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ShowMore"},[(_vm.expanded)?_vm._t("default"):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ShowMore__button mt-base",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[(_vm.expanded)?_c('p',{staticClass:"text--blue"},[_vm._v("- Show less")]):_c('p',{staticClass:"text--blue"},[_vm._v("+ Show more")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }